import type { GoodsVO } from '~/types/auto/actuator';
import type {
  ContestCountdownDTO,
  HundredProblemList,
  HundredProblemVo,
  MyLastIncompleteVO,
} from '~/types/auto/oj';
import { httpService } from '../http';

/**
 * 我的刷题记录
 */
export function getMyLastIncomplete() {
  return httpService.get<MyLastIncompleteVO>(
    `/api/code-community/api/my/lastIncomplete`,
  );
}

/**
 * 重大比赛倒计时
 */
export function getMyCountdownList() {
  return httpService.get<ContestCountdownDTO[]>(
    `/api/code-community/api/countdown/get-countdown-list`,
  );
}

/**
 * 百题斩模块
 */
export function getHundredProblem() {
  return httpService.get<HundredProblemList[]>(
    `/api/code-community/api/get-hundred-problem`,
  );
}
/**
 * 码力进阶 tab页数组
 */
export function getMaliJiejinSummary() {
  const url = `/api/code-community/api/get-mali-jiejin-summary`;
  return httpService.get<HundredProblemVo[]>(url);
}
/**
 * 码力进阶 单个tab数据
 */
export function getMaliJiejinContent(index: number) {
  const url = `/api/code-community/api/get-mali-jiejin-content`;
  return httpService.get<HundredProblemList>(url, { query: { index } });
}

/**
 * 领取完成任务对应的奖品
 */
export function getGoodsByMission(goodsId: number, missionId: number) {
  return httpService.get<GoodsVO>(
    `/api/code-community-actuator/api/user/mission/get-goods`,
    {
      query: { goodsId, missionId },
    },
  );
}

/**
 * 获取后端配置的新手引导题目ID
 */
export function getUserGuideProblem() {
  return httpService.get<number>(`/api/code-community/api/get-guide-problem`);
}
